/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, {enumMixn} from "./enumItem";

/**
 * 模板类型
 */
let EnumAuditStatus = {
	Audited: 						new EnumItem('已审核', 0),
	UnAudit: 						new EnumItem('未审核', 1),
    PartAudit: 						new EnumItem('部分审核', 2),
    NoData: 						new EnumItem('无数据', 3),
	...enumMixn
}
export default EnumAuditStatus
